import { render, staticRenderFns } from "./router.vue?vue&type=template&id=58c6c25c&scoped=true&"
import script from "./router.vue?vue&type=script&lang=js&"
export * from "./router.vue?vue&type=script&lang=js&"
import style0 from "./router.vue?vue&type=style&index=0&id=58c6c25c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c6c25c",
  null
  
)

export default component.exports